import type { GateCopy } from './types'

/**
 * Экран гейта подписки на канал.
 *
 * В 08_copy.md этой секции нет: гейт — решение основателя, пришедшее после копи-документа.
 * Тон — «своя в чате»: рубленые фразы, самоирония, без канцелярита и без нотаций. Луня не
 * требует подписки «для доступа к сервису», а честно говорит, что живёт в канале и там же
 * держит своих. Ирония не выключается — сценарий бытовой, а не тревожный (правило 19).
 */
export const gate: GateCopy = {
  title: 'Стой. Ты не в канале',
  body: 'Я живу в канале. Там разборы, звёздный шум и мои личные драмы.\nБез подписки не пущу — не потому что вредная. Ладно, немного вредная.',
  subscribe: 'Подписаться',
  /**
   * Было «Я подписалась» — женский род для всех. Склонять негде: слайс `access` по рангу
   * (domain.md §1) не видит `user`, а гейт живёт до профиля. Формулировка без рода подходит
   * всем и ничего не теряет.
   */
  check: 'Я уже в канале',
  /** Перепроверка не нашла подписки. Без обвинений: Луня грешит на себя. */
  not_found: 'Пока не вижу тебя там. Дай Телеграму секунду и жми ещё раз.',
  /** Ссылки на канал нет (приватный канал без адреса) — уводить некуда, объясняем честно. */
  no_link: 'Ссылка на канал куда-то делась. Напиши мне командой /contact — разберёмся.',
}
